/* eslint-disable @typescript-eslint/no-explicit-any */
// Select de varios valores con el mismo look de SelectField. value: array; onChange(array).
// Dentro de un campo, varios valores = OR (cualquiera de ellos). Entre campos distintos = AND.
// Un valor elegido que ya no está en las opciones (por ejemplo, cambió el rango) se sigue mostrando,
// para que nunca quede un filtro aplicado que no se ve.
// libre: además de las opciones, deja pegar cualquier valor (ej. un GUID) y buscarlo tal cual.
import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

const estilos: any = {
  control: (b: any, s: any) => ({
    ...b,
    minHeight: 44,
    borderRadius: 10,
    borderColor: s.isFocused ? 'var(--ih-primary)' : '#DADAF0',
    background: s.isFocused ? '#FFF' : '#FCFCFF',
    boxShadow: s.isFocused ? 'var(--ih-ring)' : 'none',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    '&:hover': { borderColor: s.isFocused ? 'var(--ih-primary)' : '#C4C4E6' },
  }),
  valueContainer: (b: any) => ({ ...b, padding: '4px 8px', gap: 4 }),
  placeholder: (b: any) => ({ ...b, color: '#8B8BB3', fontWeight: 500, marginLeft: 4 }),
  input: (b: any) => ({ ...b, color: 'var(--ih-navy)' }),
  multiValue: (b: any) => ({ ...b, margin: 0, background: 'var(--ih-tint)', border: '1px solid var(--ih-tint-strong)', borderRadius: 8 }),
  multiValueLabel: (b: any) => ({ ...b, color: 'var(--ih-primary-ink)', fontSize: 12.5, fontWeight: 700, padding: '2px 4px 2px 8px' }),
  multiValueRemove: (b: any) => ({
    ...b,
    color: 'var(--ih-primary-ink)',
    borderRadius: '0 8px 8px 0',
    ':hover': { background: 'var(--ih-tint-strong)', color: '#B42318' },
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  clearIndicator: (b: any) => ({ ...b, color: '#8B8BB3', padding: 6, ':hover': { color: '#E02401' } }),
  dropdownIndicator: (b: any, s: any) => ({
    ...b,
    color: '#4E4E83',
    transition: 'transform .15s',
    transform: s.selectProps.menuIsOpen ? 'rotate(180deg)' : 'none',
  }),
  menuPortal: (b: any) => ({ ...b, zIndex: 1060 }),
  menu: (b: any) => ({
    ...b,
    marginTop: 6,
    borderRadius: 12,
    border: '1px solid #DADAF0',
    boxShadow: '0 18px 50px rgba(26,26,91,.16)',
    overflow: 'hidden',
    fontFamily: "Roboto, system-ui, -apple-system, 'Segoe UI', Arial, sans-serif",
  }),
  menuList: (b: any) => ({ ...b, padding: 6 }),
  option: (b: any, s: any) => ({
    ...b,
    borderRadius: 8,
    fontSize: 13.5,
    fontWeight: s.isSelected ? 700 : 500,
    color: s.isSelected ? 'var(--ih-on-primary)' : 'var(--ih-navy)',
    background: s.isSelected ? 'var(--ih-primary)' : s.isFocused ? 'var(--ih-tint)' : 'transparent',
    cursor: 'pointer',
    ':active': { background: s.isSelected ? 'var(--ih-primary)' : 'var(--ih-tint-strong)' },
  }),
  noOptionsMessage: (b: any) => ({ ...b, fontSize: 13, color: '#4E4E83' }),
};

// Normaliza a lista de strings: acepta array, un valor suelto o vacío.
export const comoLista = (v: any): string[] => (Array.isArray(v) ? v : v ? [v] : []).map(String).filter(Boolean);

export const MultiSelectField = ({ options = [], value, onChange, placeholder = 'All', libre = false }: any) => {
  const lista = comoLista(value);
  const actual = lista.map((v) => options.find((o: any) => String(o.value) === v) || { value: v, label: v });
  const Componente: any = libre ? CreatableSelect : Select;
  const extra = libre
    ? {
        formatCreateLabel: (v: string) => `Search "${v.trim()}"`,
        createOptionPosition: 'first',
        isValidNewOption: (v: string) => v.trim().length >= 3,
        onCreateOption: (v: string) => onChange([...lista, v.trim()]),
      }
    : {};
  return (
    <Componente
      {...extra}
      isMulti
      options={options}
      value={actual}
      onChange={(arr: any) => onChange((arr || []).map((o: any) => String(o.value)))}
      placeholder={placeholder}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      isClearable
      isSearchable
      styles={estilos}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition="fixed"
      noOptionsMessage={() => 'Nothing in this range'}
    />
  );
};
